import {removeClientNote} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {clientKeys, clientMutationKeys} from "../../../../../client-keys";

export function removeClientNoteMutationOptions(clientId: string) {
  return mutationOptions({
    mutationFn: (noteId: number) => removeClientNote(clientId, noteId),
    mutationKey: clientMutationKeys.removeClientNote,
    onSuccess: async (_result, _noteId, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: clientKeys.detail(clientId)}),
        client.invalidateQueries({queryKey: clientKeys.lists()}),
      ]);
    },
  });
}
